import { gql } from '@efficiently/client-core-graphql-models';

export const GET_CONTENT_AUTOCOMPLETE_ACTIONS = gql(`
	query GetContentAutocompleteValues(
		$search: String
		$ownerFilter: ContentOwnerFilter
		$mode: ContentSearchModifier
		$projectId: String
		$timeZoneCode: String
	) {
		contentAutocompleteValues(
			args: {
				search: $search
				ownerFilter: $ownerFilter
				mode: $mode
				projectId: $projectId
				timeZoneCode: $timeZoneCode
			}
		) {
			label
			values {
				name
				value
			}
		}
	}
`);
